export class TariffTier {
  id: number;
  identifier: string;
  name: string;
}
